import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, ChevronRight } from 'lucide-react';
import { userAPI } from '../utils/api';
import authService from '../firebase/authService';

const ProfileCompletenessWidget = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    useEffect(() => {
        return authService.onAuthStateChange(setUser);
    }, []);
    const [percent, setPercent] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProfile = async () => {
            if (!user) {
                setLoading(false);
                return;
            }
            try {
                const res = await userAPI.getProfile();
                let score = 0;
                if (res?.profile) {
                    const p = res.profile;
                    if (p.identity) score += 25;
                    if (p.university || p.current_role) score += 25;
                    if (p.technical_skills && p.technical_skills.length > 0) score += 25;
                    if ((p.soft_skills && p.soft_skills.length > 0) || p.organization_code) score += 25;
                }
                setPercent(score);
            } catch (err) {
                console.error("Failed to fetch profile completeness", err);
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, [user]);

    if (loading || !user) return null;

    return (
        <div
            onClick={() => navigate('/profile')}
            className="mt-4 p-4 rounded-xl border border-cyan-500/20 bg-cyan-900/10 hover:bg-cyan-900/20 transition-all cursor-pointer group"
        >
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                    <User className="w-4 h-4 text-cyan-400" />
                    <span className="text-sm font-semibold text-white">Profile</span>
                </div>
                <span className="text-xs font-mono font-bold text-cyan-400">{percent}%</span>
            </div>

            <div className="w-full bg-gray-800 rounded-full h-1.5 mb-3 overflow-hidden">
                <div
                    className="bg-gradient-to-r from-cyan-500 to-indigo-500 h-1.5 rounded-full transition-all duration-1000"
                    style={{ width: `${percent}%` }}
                />
            </div>

            {percent < 100 ? (
                <p className="text-[10px] text-gray-400 flex items-center justify-between">
                    Complete for better roadmaps <ChevronRight className="w-3 h-3 group-hover:translate-x-1 transition-transform text-cyan-500" />
                </p>
            ) : (
                <p className="text-[10px] text-emerald-400 flex items-center justify-between">
                    Profile optimized! <ChevronRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
                </p>
            )}
        </div>
    );
};

export default ProfileCompletenessWidget;
